export default "__VITE_ASSET__DmDwmzOF__"